var map = {
	"./App": 1613,
	"./App.vue": 1613,
	"./assets/css/animate.min.css": 350,
	"./assets/css/style.css": 5549,
	"./assets/images/Bhavin_Dabhi.png": 1642,
	"./assets/images/David.png": 1881,
	"./assets/images/Elsa.png": 7515,
	"./assets/images/Junaid.png": 7449,
	"./assets/images/Mitesh.png": 3398,
	"./assets/images/dashboard/Biogains.png": 1028,
	"./assets/images/dashboard/Biogains1.png": 6882,
	"./assets/images/dashboard/Biogains2.png": 3007,
	"./assets/images/dashboard/Biogains3.png": 1867,
	"./assets/images/dashboard/Biogains4.png": 9618,
	"./assets/images/dashboard/Biogains5.png": 6319,
	"./assets/images/dashboard/CRM_for_Financial.png": 920,
	"./assets/images/dashboard/proclick.png": 6856,
	"./assets/images/dashboard/shopping_admin_dashbord.png": 2545,
	"./assets/images/logos/Ecoworld.png": 9102,
	"./assets/images/logos/Food_place.png": 4170,
	"./assets/images/logos/Kunal-Battery.png": 2835,
	"./assets/images/logos/astro_logo.png": 1902,
	"./assets/images/logos/barbershop.png": 5763,
	"./assets/images/logos/code_infinity.png": 7790,
	"./assets/images/logos/electro.png": 5479,
	"./assets/images/logos/finalcial_insight.png": 4970,
	"./assets/images/logos/hippo_mall.png": 3102,
	"./assets/images/logos/jewelpearl.png": 1637,
	"./assets/images/logos/pethouse.png": 1229,
	"./assets/images/logos/studio.png": 4926,
	"./assets/images/mobie_app/FoodMonkey.png": 3261,
	"./assets/images/mobie_app/Nft32.1.png": 7019,
	"./assets/images/mobie_app/Nft3d.png": 9771,
	"./assets/images/mobie_app/Sport_app_ui.png": 6578,
	"./assets/images/mobie_app/Unboarding_UI.png": 1977,
	"./assets/images/mobie_app/Wallet1.png": 8830,
	"./assets/images/mobie_app/Wallet2.png": 2401,
	"./assets/images/mobie_app/Wallet3.png": 5709,
	"./assets/images/mobie_app/Wallet4.png": 8417,
	"./assets/images/mobie_app/Wallet5.png": 471,
	"./assets/images/mobie_app/Wallet6.png": 2529,
	"./assets/images/mobie_app/Wallet7.png": 2117,
	"./assets/images/mobie_app/car_game.webp": 9300,
	"./assets/images/mobie_app/car_game1.webp": 4670,
	"./assets/images/mobie_app/clothwebsite.png": 3978,
	"./assets/images/mobie_app/dollar_bucket.webp": 7044,
	"./assets/images/mobie_app/food_orders.png": 509,
	"./assets/images/mobie_app/matemagic1.png": 8728,
	"./assets/images/mobie_app/matemagic2.png": 2506,
	"./assets/images/mobie_app/matemagic3.png": 101,
	"./assets/images/mobie_app/matemagic4.png": 1415,
	"./assets/images/mobie_app/matemagic5.png": 5529,
	"./assets/images/mobie_app/matemagic6.png": 4759,
	"./assets/images/mobie_app/matemagic7.png": 3988,
	"./assets/images/mobie_app/money_manager_app.webp": 368,
	"./assets/images/mobie_app/nurse_job_1.png": 9917,
	"./assets/images/mobie_app/nurse_job_2.png": 8879,
	"./assets/images/mobie_app/nurse_job_3.png": 5517,
	"./assets/images/mobie_app/nurse_job_4.png": 738,
	"./assets/images/mobie_app/nurse_job_5.png": 4487,
	"./assets/images/mobie_app/portal_app_ui.png": 9250,
	"./assets/images/mobie_app/shooping.png": 5418,
	"./assets/images/mobie_app/social_app.png": 6570,
	"./assets/images/mobie_app/story_maker.webp": 6181,
	"./assets/images/mobie_app/vpn1.png": 6243,
	"./assets/images/mobie_app/vpn2.png": 3158,
	"./assets/images/mobie_app/vpn3.png": 3479,
	"./assets/images/mobie_app/vpn4.png": 979,
	"./assets/images/mobie_app/vpn5.png": 8900,
	"./assets/images/mobie_app/vpn6.png": 7202,
	"./assets/images/mobie_app/webfix.png": 3746,
	"./assets/images/ppt/ppt1.png": 3365,
	"./assets/images/ppt/ppt2.png": 8754,
	"./assets/images/roger.png": 8458,
	"./assets/images/screenshot/app_screenshort_1.png": 5532,
	"./assets/images/screenshot/app_screenshort_2.1.png": 9298,
	"./assets/images/screenshot/app_screenshort_2.png": 724,
	"./assets/images/screenshot/app_screenshort_3.1.png": 1459,
	"./assets/images/screenshot/app_screenshort_3.png": 8996,
	"./assets/images/services/app_screenshot.png": 5580,
	"./assets/images/services/banners.png": 9576,
	"./assets/images/services/blogo.png": 4853,
	"./assets/images/services/dashboard.png": 6245,
	"./assets/images/services/mobile_app.png": 6463,
	"./assets/images/services/presentation.png": 4743,
	"./assets/images/services/website_ui.png": 2988,
	"./assets/images/services/wireframing.png": 3656,
	"./assets/images/video_bhavin_dabhi.mp4": 5239,
	"./assets/images/website/divi.png": 6091,
	"./assets/images/website/divi1.png": 7864,
	"./assets/images/website/lighting-website.png": 5771,
	"./assets/images/website/media-agency-website.png": 5673,
	"./assets/images/website/portfolio-website.png": 3314,
	"./assets/images/website/product_sell.png": 8636,
	"./assets/images/website/product_sell1.png": 6094,
	"./assets/images/website/product_sell2.png": 6098,
	"./assets/images/website/product_sell3.png": 263,
	"./assets/images/website/product_sell4.png": 1174,
	"./assets/images/website/product_sell_price.png": 7912,
	"./assets/images/website/savoy_shopping.png": 1309,
	"./assets/images/website/shopping_website.png": 6401,
	"./assets/images/wireframing/recipes.png": 2014,
	"./assets/images/youtube_thumbnail.png": 5544,
	"./assets/js/custom": 8454,
	"./assets/js/custom.js": 8454,
	"./assets/logo.png": 6949,
	"./components/Filterimage": 8534,
	"./components/Filterimage.vue": 8534,
	"./components/ModelPopup": 4950,
	"./components/ModelPopup.vue": 4950,
	"./global-components": 2738,
	"./global-components/": 2738,
	"./global-components/index": 2738,
	"./global-components/index.js": 2738,
	"./json/app": 3117,
	"./json/app.json": 3117,
	"./json/appscreenshot": 4392,
	"./json/appscreenshot.json": 4392,
	"./json/bhavindata": 1576,
	"./json/bhavindata.json": 1576,
	"./json/customerreview": 6011,
	"./json/customerreview.json": 6011,
	"./json/dashboard": 8452,
	"./json/dashboard.json": 8452,
	"./json/logo": 5535,
	"./json/logo.json": 5535,
	"./json/website": 1143,
	"./json/website.json": 1143,
	"./json/wireframing": 1562,
	"./json/wireframing.json": 1562,
	"./layouts/Footer": 8237,
	"./layouts/Footer.vue": 8237,
	"./layouts/HeroSection": 391,
	"./layouts/HeroSection.vue": 391,
	"./layouts/TopBar": 5396,
	"./layouts/TopBar.vue": 5396,
	"./main": 866,
	"./main.js": 866,
	"./router": 1120,
	"./router/": 1120,
	"./router/index": 1120,
	"./router/index.js": 1120,
	"./views/Aboutme": 5187,
	"./views/Aboutme.vue": 5187,
	"./views/Clientsreview": 736,
	"./views/Clientsreview.vue": 736,
	"./views/HomePage": 4665,
	"./views/HomePage.vue": 4665,
	"./views/Portfolio": 1036,
	"./views/Portfolio.vue": 1036,
	"./views/Resume": 2289,
	"./views/Resume.vue": 2289,
	"./views/Service": 4961,
	"./views/Service.vue": 4961,
	"./views/portfolio/Logo": 2234,
	"./views/portfolio/Logo.vue": 2234,
	"./views/portfolio/Portfoliomore": 7949,
	"./views/portfolio/Portfoliomore.vue": 7949,
	"./views/portfolio/appui": 9321,
	"./views/portfolio/appui.vue": 9321,
	"./views/portfolio/dashboard": 8354,
	"./views/portfolio/dashboard.vue": 8354,
	"./views/portfolio/screenshot": 6978,
	"./views/portfolio/screenshot.vue": 6978,
	"./views/portfolio/website": 7131,
	"./views/portfolio/website.vue": 7131,
	"./views/portfolio/wireframing": 7439,
	"./views/portfolio/wireframing.vue": 7439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;